import React, {useEffect, useState} from "react";
import axios from "axios";
import "../Styles/Content.css";
import SearchTab from "../Components/SearchTab";
import { useParams } from "react-router-dom";
import {API_ROOT,webPath} from "../apiConfig";
import {Helmet} from "react-helmet"
import LazyLoad from 'react-lazyload';
import AdCarousel from "../ReusableComp/Carasoul";


const Searchlist = () => {
  const {  searchVal } = useParams();

  const [advertisementData, setAdvertisementData] = useState([]);
     const [homeAdvertise,setHomeAdvertise]=useState([]);
     const[footerAd,setFooterAd]=useState([]);
  useEffect(() => {
    const fetchAdvertisementData = async () => {
      try {
        const response = await axios.get(`${API_ROOT}/api/advertisement/get_active`);
        setAdvertisementData(response.data);
        setHomeAdvertise(response.data.filter(item => item.banner_type === "Home-2"))
        setFooterAd(response.data.filter(item => item.banner_type === "Footer-3"))
        // console.log(response.data)
      } catch (error) {
        console.error('Error fetching advertisement data:', error);
      }
    };
  
    fetchAdvertisementData();
  }, []); // The empty dependency array ensures that this effect runs once when the component mounts
  
  const canonicalUrl = `https://enterprisetalk.com/${searchVal}`

  const [className, setClassName] = useState('');
  
  useEffect(() => {
    const sections = 5; 
    let currentSection = 1;
  
    const setSectionClassName = () => {
      
      const removeTimer = setTimeout(() => {
        setClassName('');
      }, 0);
  
     
      const setTimer = setTimeout(() => {
        setClassName('loaded');
        currentSection++;
  
        
        if (currentSection <= sections) {
          setSectionClassName();
        }
      }, currentSection * 30); 
  
    
      return () => {
        clearTimeout(removeTimer);
        clearTimeout(setTimer);
      };
    };
  
    setSectionClassName();
  }, []); 


  return (
    <div>

<Helmet>
      <title>You searched for {searchVal} - Enterprise Talk</title>
	<meta name="description" content="A Peer Knowledge Resource Expert inputs on challenges, triumphs &amp; innovative solutions from corporate Movers &amp; Shakers in global Leadership." />
	<link rel="canonical" href={canonicalUrl} />
      </Helmet> 


      <div className="container container-max"  id='datas'>
        <div className="row">

            
          <div className="col-md-12">
            {/* <h1 className="fw-bold py-1 mt-3">Search Result : {searchVal}</h1> */}
          
          </div>
          {/* <div className="hr"></div> */}
          </div>
          <LazyLoad className={className}>
          <SearchTab />
          </LazyLoad>

          <LazyLoad className={className}>
          <div className="container container-max ">
        <div className="row mt-5 spaceincontentbottm">
          <div className="col-md-12 mb-2 borderB">
            {/* <div >
            {footerAd && footerAd.length > 0 && (
             <a href={`${footerAd[0].dest_url}`}> <img
                style={{ width: "100%" }}
                src={`${webPath}${footerAd[0].banner_img}`}
                alt={footerAd[0].banner_name}
              /> </a>
            )}
            </div> */}
              <AdCarousel ads={footerAd} className={className} />
          </div>
        </div>
          </div>
      </LazyLoad>


       

        
      </div>
    </div>
  );
};

export default Searchlist;
